
export const formatPlotScale = (plot, config)=>{
    if (config.yScale) {
        plot.yScale().comparisonMode(config.yScale);
      }
      if (config.stack){
          plot.yScale().stackMode('value');
      }
      if (config.yMax){
          plot.yScale().maximum(config.yMax);
      }
}